import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyPlanAlarmCommunicationSection({ section, sectionNumber = 3 }) {
  const data = section && section.data ? section.data : {};
  const items = Array.isArray(data.items)
    ? data.items.filter((item) => item && [item.element, item.required_arrangement]
      .some((value) => String(value || "").trim() !== ""))
    : [];
  const displayName = section && section.display_name
    ? section.display_name
    : "Alarm, Communication & Emergency Access";

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <table className={`${styles.PreviewTable} ${styles.EmergencyPlanScenarioTable}`}>
          <thead className={styles.EmergencyPlanScenarioTableHead}>
            <tr>
              <th style={{ width: "35%" }}>Element</th>
              <th style={{ width: "65%" }}>Required Arrangement</th>
            </tr>
          </thead>
          <tbody>
            {items.length > 0 ? items.map((item, index) => (
              <tr key={item.id || index}>
                <td>{item.element || <span>&mdash;</span>}</td>
                <td>{item.required_arrangement || <span>&mdash;</span>}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan={2} className={styles.PreviewTableEmpty}>No alarm, communication, or emergency access arrangements available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
